import { useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useUserState } from "./state/user";
import { useTranslation } from "react-i18next";
import { PAYMENTS_HOME_PATH } from "./utils/paymentsRoutes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faCircleDollarToSlot,
  faPrescription,
  faUsers
} from "@fortawesome/free-solid-svg-icons";
import CardHome from "./components/home/Card/Card";
import VideoCard from "./components/home/Card/VideoCard";
import { semanticColors } from "./utils/colors";
import { typography } from "./utils/typography";

export default function Home() {
  const { user } = useUserState();
  const history = useHistory();
  const { t } = useTranslation();

  const getWelcome = () => {
    const g = user?.personalInfo?.gender;
    if (g === 1) return t("home.welcomeMale");
    if (g === 2) return t("home.welcomeFemale");
    return t("home.welcomeNeutral");
  };

  const getClinicalDisplayName = () => {
    const g = user?.personalInfo?.gender;
    const title =
      g === 1 ? t("home.titleMale") : g === 2 ? t("home.titleFemale") : "";
    return title ? `${title} ${user?.clinicalName}` : user?.clinicalName;
  };

  const cardsList = [
    {
      id: 1,
      title: t("home.signPrescriptions"),
      fn: () => (window.location.href = "https://sign.myscribo.com/"),
      image: "menu2.jpg",
      imgStyles: { objectPosition: "right bottom" },
      icon: <FontAwesomeIcon icon={faPrescription} size="2x" color="white" />
    },
    {
      id: 2,
      title: t("home.paymentsAccount"),
      fn: () => history.push(PAYMENTS_HOME_PATH),
      image: "menu1.jpg",
      imgStyles: { objectPosition: "left bottom" },
      icon: (
        <FontAwesomeIcon icon={faCircleDollarToSlot} size="2x" color="white" />
      )
    },
    {
      id: 3,
      title: t("home.purchases"),
      fn: () => history.push("/cmds/buy"),
      image: "menu3.jpg",
      imgStyles: { objectPosition: "center bottom" },
      icon: <FontAwesomeIcon icon={faCartShopping} size="2x" color="white" />
    },
    {
      id: 4,
      title: t("home.utentes"),
      fn: () => history.push("/patients"),
      image: "menu4.jpg",
      imgStyles: { objectPosition: "center center" },
      icon: <FontAwesomeIcon icon={faUsers} size="2x" color="white" />
    }
  ];

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        bgcolor: semanticColors.surface.canvas,
        marginTop: "-80px"
      }}
    >
      {/* Dashboard gradient — 320px from viewport top, covers behind transparent navbar */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 320,
          background: semanticColors.gradient.dashboard,
          zIndex: 0
        }}
      />

      {/* Content section */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "48px",
          pt: "100px",
          pb: "48px",
          px: { xs: "16px", sm: "32px", lg: "64px" }
        }}
      >
        {/* Welcome text */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            height: 72
          }}
        >
          <Typography
            sx={{
              ...typography.heading.sRegular,
              color: semanticColors.text.inverse,
              textAlign: "center"
            }}
          >
            {getWelcome()}
          </Typography>
          <Typography
            sx={{
              ...typography.heading.xl,
              color: semanticColors.text.inverse,
              textAlign: "center"
            }}
          >
            {getClinicalDisplayName()}!
          </Typography>
        </Box>

        {/* White cards container */}
        <Box
          sx={{
            width: "100%",
            bgcolor: semanticColors.text.inverse,
            borderRadius: "44px",
            p: "24px",
            display: "flex",
            flexDirection: "row",
            gap: "24px",
            boxShadow: "0px 4px 6px rgba(30, 39, 79, 0.1)",
            flexWrap: { xs: "wrap", md: "nowrap" },
            justifyContent: { xs: "center", md: "flex-start" }
          }}
        >
          <Box
            sx={{
              flex: 1,
              minWidth: { xs: "calc(50% - 12px)", md: 0 },
              maxWidth: { xs: "calc(50% - 12px)", md: "none" }
            }}
          >
            <VideoCard onClick={() => history.push("/video")} />
          </Box>
          {cardsList.map(data => (
            <Box
              key={data.id}
              sx={{
                flex: 1,
                minWidth: { xs: "calc(50% - 12px)", md: 0 },
                maxWidth: { xs: "calc(50% - 12px)", md: "none" }
              }}
            >
              <CardHome
                title={data.title}
                onClick={data.fn}
                image={data.image}
                imgStyles={data.imgStyles}
                icon={data.icon}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
